// extracted by mini-css-extract-plugin
export default {"boxContent":"JP_Production_boxContent__wtEJc","contentTab":"JP_Production_contentTab__nAuPX","backgroundImg":"JP_Production_backgroundImg__dIHEb"};